import ReactSelect from "react-select/creatable";
const StyledSelect = ({ oneLine, ...props }) => (
  <ReactSelect style={{ width: oneLine ? "100%" : undefined }} {...props} />
);

const Select = ({ oneLine = false, label, ...props }: any) => {
  return (
    <div className="items-center md:block" style={{ display: oneLine ? "flex" : "block", width: oneLine ? "100%" : undefined }}>
      {label && (
        <div className="font-semibold md:mb-[1rem]" style={{ marginBottom: !oneLine ? "1rem" : undefined, marginRight: oneLine ? "1rem" : undefined }}>
          {label}
        </div>
      )}
      <StyledSelect oneLine={oneLine} {...props} />
    </div>
  );
};

Select.defaultProps = {
  classNamePrefix: "react-select",
};
export default Select;
